import { useEffect, useState } from "react";
import { getToken } from "firebase/messaging";
import { messaging } from "./firebaseConfig";

export const useFcmToken = () => {
  const [fcmToken, setFcmToken] = useState("");

  useEffect(() => {
    let cancelled = false;
    let attempts = 0;

    const requestPermission = async () => {
      const native = window.__RSP_NATIVE_FCM_TOKEN__;
      if (native) {
        if (!cancelled) setFcmToken(native);
        return;
      }

      if (!messaging && attempts < 10) {
        attempts += 1;
        setTimeout(requestPermission, 500);
        return;
      }

      if (!messaging) return;

      try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
          if ("serviceWorker" in navigator) {
            try {
              const token = await getToken(messaging, {
                vapidKey: process.env.REACT_APP_VAPID_KEY,
              });

              if (token) {
                if (!cancelled) setFcmToken(token);
              } else {
                console.log("No FCM Token received");
              }
            } catch (tokenError) {
              console.error("Error getting FCM token:", String(tokenError));
            }
          } else {
            console.error("Service Worker is not supported in this browser");
          }
        } else if (permission === "denied") {
          console.log("Notification permission denied");
        } else {
          console.log("Notification permission request dismissed");
        }
      } catch (error) {
        console.error("Error during notification permission request:", String(error));
      }
    };

    requestPermission();
    return () => {
      cancelled = true;
    };
  }, []);

  return fcmToken;
};
